import React from "react";

import { renderToStaticMarkup } from "@hot-loader/react-dom/server";
import parse from "html-react-parser";

export const renderMarkup = (
  content,
  advisor,
  selectedHub,
  newComment = false
) => {
  let updatedContent;
  if (newComment) {
    // Include the advisor name in comments because they don't show up otherwise
    const isRedtail =
      advisor.integrations.find((i) => {
        return i.hubId === selectedHub.id;
      })?.type === "redtail";
    const commentHeader = isRedtail
      ? `<b>${advisor.firstName && advisor.firstName} ${
          advisor.lastName && advisor.lastName
        } Wrote:</b><br/><br/>`
      : "";
    updatedContent = commentHeader + content;
  } else {
    updatedContent = content;
  }

  const parsedBody = parse(updatedContent, {
    replace: (domNode) => {
      // Add // to links without http or https at start
      if (domNode.attribs && domNode.attribs.href) {
        let url = domNode.attribs.href;
        if (
          !domNode.attribs.href.startsWith("http://") &&
          !domNode.attribs.href.startsWith("https://") &&
          !domNode.attribs.href.startsWith("//") &&
          !domNode.attribs.href.startsWith("mailto:")
        ) {
          url = `//${domNode.attribs.href}`;
        }
        return React.createElement(
          "a",
          { href: url, target: "_blank" },
          domNode.children.length > 0 ? domNode.children[0].data : url
        );
      }
      return domNode;
    },
  });
  return renderToStaticMarkup(parsedBody);
};

export default renderMarkup;
